import ScreenShots from "./ScreenShots";
export default ScreenShots;